import { render, staticRenderFns } from "./ModuleUpdated.vue?vue&type=template&id=38996d54"
import script from "./ModuleUpdated.vue?vue&type=script&lang=js"
export * from "./ModuleUpdated.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports